// extracted by mini-css-extract-plugin
export default {"branches":"branches_branches__vg17w","branch":"branches_branch__WH6kH","branchName":"branches_branchName__gEaoa","createBranchForm":"branches_createBranchForm__S2pXv"};